import { useMemo } from 'react'
import { useQueryDeliveryCompanies } from 'hooks/masterData'
import { SelectOption } from 'types/common'

const useDeliveryCompanyOptions = (): SelectOption[] => {
  const deliveryCompanies = useQueryDeliveryCompanies()
  return useMemo(() => {
    const options: SelectOption[] = [{ label: '未選択', value: '' }]
    deliveryCompanies.map((deliveryCompany) => {
      options.push({ label: deliveryCompany.displayName, value: deliveryCompany.code })
    })
    return options
  }, [deliveryCompanies])
}

export default useDeliveryCompanyOptions
